import TtamScheduleSplittestTips from './splittest-tips/index.vue';
import TtamScheduleSplittestLabel from './splittest-label/index.vue';
import TtamScheduleSplittestLabelHint from './splittest-label-hint/index.vue';
import TtamScheduleContinuousRadio from './continuous-radio/index.vue';
import TtamScheduleDaterangeRadio from './daterange-radio/index.vue';
import TtamScheduleContinuousTimepicker from './continuous-timepicker/index.vue';
import TtamScheduleDaterangeTimepicker from './daterange-timepicker/index.vue';
import TtamScheduleTimezone from './timezone/index.vue';
import TtamScheduleTimezoneDesc from './timezone-desc/index.vue';
import TtamScheduleTimeConverterDialog from './time-converter/index.vue';
import TtamScheduleStartTimeDatePicker from './starttime-datepicker/index.vue';
import TtamScheduleEndTimeDatePicker from './endtime-datepicker/index.vue';
import TtamScheduleLabel from './label/index.vue';
import TtamScheduleShopliveTips from './shoplive-tips/index.vue';
import TtamScheduleDstTips from './dst-tips/index.vue';
import TtamScheduleDateDurationTimepicker from './dateduration-timepicker/index.vue';
import TtamScheduleDateDurationRadio from './dateduration-radio/index.vue';

import * as hooks from './hooks';

export default {
  TtamScheduleStartTimeDatePicker,
  TtamScheduleEndTimeDatePicker,
  TtamScheduleSplittestLabelHint,
  TtamScheduleSplittestTips,
  TtamScheduleSplittestLabel,
  TtamScheduleContinuousRadio,
  TtamScheduleDaterangeRadio,
  TtamScheduleTimezone,
  TtamScheduleTimezoneDesc,
  TtamScheduleTimeConverterDialog,
  TtamScheduleLabel,
  TtamScheduleContinuousTimepicker,
  TtamScheduleDaterangeTimepicker,
  TtamScheduleDateDurationTimepicker,
  TtamScheduleDateDurationRadio,
  TtamScheduleShopliveTips,
  TtamScheduleDstTips,
  ...hooks,
};
